
import React from "react";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AIStaffMember } from "@/lib/types";

interface TerminatedStaffViewProps {
  aiStaff: AIStaffMember;
}

const TerminatedStaffView: React.FC<TerminatedStaffViewProps> = ({ aiStaff }) => {
  const navigate = useNavigate();
  
  return (
    <div className="text-center py-12">
      <div className="mx-auto bg-amber-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
        <AlertCircle className="h-8 w-8 text-amber-500" />
      </div>
      <h3 className="text-xl font-medium mb-2">Staff Member Terminated</h3>
      <p className="text-muted-foreground mb-6">
        {aiStaff.name} is no longer active. Would you like to hire a new AI staff member?
      </p>
      <Button onClick={() => navigate("/staff")}>
        Hire New AI Staff
      </Button>
    </div>
  );
};

export default TerminatedStaffView;
